import React from "react";
import { imageUrl } from "../../actions/miscAction";
import { Modal } from "react-bootstrap";
import _ from "lodash";

const chevronLeft = imageUrl("chevron-left-angle.svg");

const MobileFilter = (props) => {
  return (
    <Modal
      className="modal left-collapse fade"
      id="pipeCollapse"
      tabindex="-1"
      role="dialog"
      dialogClassName="modal-dialog"
      show={props.show}
      onHide={() => props.onHide()}
    >
      <div class="modal-content">
        <div class="filter-collapse-content">
          <div class="fcc-header d-flex align-items-center justify-content-between">
            <div class="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => props.onHide()}>
              <img src={chevronLeft} alt="chevronLeft" />
            </div>
            <h3 class="fcc-title" id="myModalLabel">
              Filters
            </h3>
            <small
              onClick={() =>
                props.setFilterValues({
                  partNumber: "",
                  partDescription: "",
                  planeParts: [],
                  planeCondition: [],
                  certificates: "",
                  warranty: "",
                  manufacturerParts: [],
                  planeModel: [],
                })
              }
            >
              Clear filters
            </small>
          </div>
          <div class="fcc-body">
            <div class="fcc-tab-container d-flex">
              <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                <a
                  class={`nav-link ${props.tab == "1" ? "active" : ""}`}
                  id="v-pills-tab-A-tab"
                  onClick={() => props.setTab("1")}
                >
                  Part Number
                </a>
                <a
                  class={`nav-link ${props.tab == "9" ? "active" : ""}`}
                  id="v-pills-tab-A-tab"
                  onClick={() => props.setTab("9")}
                >
                  Part Description
                </a>
                {/* <a
                  class={`nav-link ${props.tab == "2" ? "active" : ""}`}
                  id="v-pills-tab-B-tab"
                  onClick={() => props.setTab("2")}
                >
                  Part of the Plane
                </a> */}
                <a
                  class={`nav-link ${props.tab == "3" ? "active" : ""}`}
                  id="v-pills-tab-C-tab"
                  onClick={() => props.setTab("3")}
                >
                  Condition
                </a>
                <a
                  class={`nav-link ${props.tab == "4" ? "active" : ""}`}
                  id="v-pills-tab-D-tab"
                  onClick={() => props.setTab("4")}
                >
                  Certificates
                </a>
                {/*<a
                  class={`nav-link ${props.tab == "5" ? "active" : ""}`}
                  id="v-pills-tab-E-tab"
                  onClick={() => props.setTab("5")}
                >
                  Warranty
                </a>
                <a
                  class={`nav-link ${props.tab == "6" ? "active" : ""}`}
                  id="v-pills-tab-F-tab"
                  onClick={() => props.setTab("6")}
                >
                  Part Manufacturer
                </a>
                <a
                  class={`nav-link ${props.tab == "7" ? "active" : ""}`}
                  id="v-pills-tab-G-tab"
                  onClick={() => props.setTab("7")}
                >
                  Plane Model
                </a> */}
              </div>
              <div class="tab-content" id="v-pills-tabContent">
                <div
                  class={`tab-pane fade ${props.tab == "1" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    <input
                      class="form-control"
                      type="text"
                      value={props?.filterValues?.partNumber}
                      onChange={(e) => {
                        const data = { ...props.filterValues };
                        data.partNumber = e.target.value;
                        props.setFilterValues(data);
                      }}
                      placeholder="Enter Part Number"
                    />
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "9" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    <input
                      class="form-control"
                      type="text"
                      value={props?.filterValues?.partDescription}
                      onChange={(e) => {
                        const data = { ...props.filterValues };
                        data.partDescription = e.target.value;
                        props.setFilterValues(data);
                      }}
                      placeholder="Enter Part Description"
                    />
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "2" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    {props.count &&
                      props.count?.planePartCounts?.length > 0 &&
                      props.count?.planePartCounts.map((item, c) =>
                        item?.planePart != "" ? (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id={`${item?.planePart}mobileFilter`}
                              checked={props.filterValues?.planeParts?.some((ed) => ed == item?.planePart)}
                            />

                            <label
                              class="form-check-label"
                              for={`${item?.planePart}mobileFilter`}
                              onClick={(e) => {
                                const a = props.filterValues?.planeParts;
                                if (!a?.some((ed) => ed == item?.planePart)) {
                                  const data = { ...props.filterValues };
                                  data.planeParts.push(item?.planePart);
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.planeParts && data.planeParts?.length > 0
                                      ? data.planeParts.filter((it) => it != item?.planePart)
                                      : [];
                                  data.planeParts = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item.planePart ? item?.planePart : "[None Specified]"} ({item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ) : (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id={`${item?.planePart}NA`}
                              checked={props.filterValues?.planeParts?.some((ed) => ed == "NA")}
                            />

                            <label
                              class="form-check-label"
                              for={`${item?.planePart}NA`}
                              onClick={(e) => {
                                const a = props.filterValues?.planeParts;
                                if (!a?.some((ed) => ed == "NA")) {
                                  const data = { ...props.filterValues };
                                  data.planeParts.push("NA");
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.planeParts && data.planeParts?.length > 0
                                      ? data.planeParts.filter((it) => it != "NA")
                                      : [];
                                  data.planeParts = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item.planePart ? item?.planePart : "[None Specified]"} ({item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ),
                      )}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "3" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    {!props.loading &&
                      props.count &&
                      props.count?.planeConditionCounts?.length > 0 &&
                      props.count?.planeConditionCounts.map((item, c) =>
                        item.condition != "" ? (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id={`${item?.condition}mobileFilter`}
                              checked={props.filterValues?.planeCondition?.some((ed) => ed == item?.condition)}
                            />
                            <label
                              class="form-check-label"
                              for={`${item?.condition}mobileFilter`}
                              onClick={(e) => {
                                const a = props.filterValues?.planeCondition;
                                if (!a?.some((ed) => ed == item?.condition)) {
                                  const data = { ...props.filterValues };
                                  data.planeCondition.push(item?.condition);
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.planeCondition && data.planeCondition?.length > 0
                                      ? data.planeCondition.filter((it) => it != item.condition)
                                      : [];
                                  data.planeCondition = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item.condition ? item?.condition : "[None Specified]"} ({item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ) : (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id={`${item.condition}NA`}
                              checked={props.filterValues?.planeCondition?.some((ed) => ed == "NA")}
                            />
                            <label
                              class="form-check-label"
                              for={`${item.condition}NA`}
                              onClick={(e) => {
                                const a = props.filterValues?.planeCondition;
                                if (!a?.some((ed) => ed == "NA")) {
                                  const data = { ...props.filterValues };
                                  data.planeCondition.push("NA");
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.planeCondition && data.planeCondition?.length > 0
                                      ? data.planeCondition.filter((it) => it != "NA")
                                      : [];
                                  data.planeCondition = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item.condition ? item?.condition : "[None Specified]"} ({item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ),
                      )}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "4" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    {props.count?.certificateCounts && props.count?.certificateCounts.length > 0
                      ? props.count?.certificateCounts.map(
                          (item) =>
                            item.certificate &&
                            item.count > 0 && (
                              <div class="form-check d-flex align-items-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="CertificatesYES"
                                  checked={props.filterValues?.certificates == "Yes"}
                                />
                                <label
                                  class="form-check-label"
                                  for=" CertificatesYES"
                                  onClick={(e) => {
                                    const data = { ...props.filterValues };
                                    data.certificates = "Yes";
                                    props.setFilterValues(data);
                                  }}
                                >
                                  Yes ({item?.count})
                                </label>
                              </div>
                            ),
                        )
                      : ""}
                    {props.count?.certificateCounts && props.count?.certificateCounts.length > 0
                      ? props.count?.certificateCounts.map(
                          (item) =>
                            _.isBoolean(item?.certificate) &&
                            !item?.certificate &&
                            item.count > 0 && (
                              <div class="form-check d-flex align-items-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="CertificatesNO"
                                  checked={props.filterValues?.certificates == "No"}
                                />
                                <label
                                  class="form-check-label"
                                  for="CertificatesNO"
                                  onClick={(e) => {
                                    const data = { ...props.filterValues };
                                    data.certificates = "No";
                                    props.setFilterValues(data);
                                  }}
                                >
                                  No ({item?.count})
                                </label>
                              </div>
                            ),
                        )
                      : ""}
                    {props.count?.certificateCounts && props.count?.certificateCounts.length > 0
                      ? props.count?.certificateCounts.map(
                          (item) =>
                            _.isNull(item?.certificate) &&
                            item.count > 0 && (
                              <div class="form-check d-flex align-items-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="CertificatesNA"
                                  checked={props.filterValues?.certificates == "NA"}
                                />
                                <label
                                  class="form-check-label"
                                  for="CertificatesNA"
                                  onClick={(e) => {
                                    const data = { ...props.filterValues };
                                    data.certificates = "NA";
                                    props.setFilterValues(data);
                                  }}
                                >
                                  [None Specified] ({item?.count})
                                </label>
                              </div>
                            ),
                        )
                      : ""}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "5" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    {props.count?.warrantyCounts && props.count?.warrantyCounts.length > 0
                      ? props.count?.warrantyCounts.map(
                          (item) =>
                            item.warranty &&
                            item.count > 0 && (
                              <div class="form-check d-flex align-items-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="WarrantyYES"
                                  checked={props.filterValues?.warranty == "Yes"}
                                />
                                <label
                                  class="form-check-label"
                                  for="WarrantyYES"
                                  onClick={(e) => {
                                    const data = { ...props.filterValues };
                                    data.warranty = "Yes";
                                    props.setFilterValues(data);
                                  }}
                                >
                                  Yes ({item.count})
                                </label>
                              </div>
                            ),
                        )
                      : ""}
                    {props.count?.warrantyCounts && props.count?.warrantyCounts.length > 0
                      ? props.count?.warrantyCounts.map(
                          (item) =>
                            _.isBoolean(item?.warranty) &&
                            !item?.warranty &&
                            item.count > 0 && (
                              <div class="form-check d-flex align-items-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  id="WarrantyNO"
                                  checked={props.filterValues?.warranty == "No"}
                                />
                                <label
                                  class="form-check-label"
                                  for="WarrantyNO"
                                  onClick={(e) => {
                                    const data = { ...props.filterValues };
                                    data.warranty = "No";
                                    props.setFilterValues(data);
                                  }}
                                >
                                  No ({item.count})
                                </label>
                              </div>
                            ),
                        )
                      : ""}{" "}
                    {props.count?.warrantyCounts && props.count?.warrantyCounts.length > 0
                      ? props.count?.warrantyCounts.map(
                          (item) =>
                            _.isNull(item?.warranty) &&
                            item.count > 0 && (
                              <div class="form-check d-flex align-items-center">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="WarrantyNA"
                                  checked={props.filterValues?.warranty == "NA"}
                                />
                                <label
                                  class="form-check-label"
                                  for="WarrantyNA"
                                  onClick={(e) => {
                                    const data = { ...props.filterValues };
                                    data.warranty = "NA";
                                    props.setFilterValues(data);
                                  }}
                                >
                                  [None Specified] ({item.count})
                                </label>
                              </div>
                            ),
                        )
                      : ""}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "6" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    {props.count &&
                      props.count?.planePartManufacturerCounts?.length > 0 &&
                      props.count?.planePartManufacturerCounts?.map((item, c) =>
                        item?.partManufacturer != "" ? (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id={`${item?.partManufacturer}mobileFilter`}
                              checked={props.filterValues?.manufacturerParts?.some(
                                (ed) => ed == item?.partManufacturer,
                              )}
                            />
                            <label
                              class="form-check-label"
                              for={`${item?.partManufacturer}mobileFilter`}
                              onClick={(e) => {
                                const a = props.filterValues?.manufacturerParts;
                                if (!a?.some((ed) => ed == item?.partManufacturer)) {
                                  const data = { ...props.filterValues };
                                  data.manufacturerParts.push(item?.partManufacturer);
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.manufacturerParts && data.manufacturerParts?.length > 0
                                      ? data.manufacturerParts.filter((it) => it != item.partManufacturer)
                                      : [];
                                  data.manufacturerParts = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item?.partManufacturer ? item?.partManufacturer : "[None Specified]"} (
                              {item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ) : (
                          <div class="form-check d-flex align-items-center" key={c}>
                            <input
                              class="form-check-input"
                              type="checkbox"
                              value=""
                              id={`${item?.partManufacturer}NA`}
                              checked={props.filterValues?.manufacturerParts?.some((ed) => ed == "NA")}
                            />
                            <label
                              class="form-check-label"
                              for={`${item?.partManufacturer}NA`}
                              onClick={(e) => {
                                const a = props.filterValues?.manufacturerParts;
                                if (!a?.some((ed) => ed == "NA")) {
                                  const data = { ...props.filterValues };
                                  data.manufacturerParts.push("NA");
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.manufacturerParts && data.manufacturerParts?.length > 0
                                      ? data.manufacturerParts.filter((it) => it != "NA")
                                      : [];
                                  data.manufacturerParts = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item?.partManufacturer ? item?.partManufacturer : "[None Specified]"} (
                              {item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ),
                      )}
                  </div>
                </div>
                <div
                  class={`tab-pane fade ${props.tab == "7" ? "show active" : ""}`}
                  id="v-pills-pane-A"
                  role="tabpanel"
                >
                  <div class="tab-content-box pl-20">
                    {props.count &&
                      props.count?.planeModelCounts?.length > 0 &&
                      props.count?.planeModelCounts.map((item, c) =>
                        item?.planeModel != "" ? (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id={`${item?.planeModel}mobileFilter`}
                              checked={props.filterValues?.planeModel?.some((ed) => ed == item?.planeModel)}
                            />
                            <label
                              class="form-check-label"
                              for={`${item?.planeModel}mobileFilter`}
                              onClick={(e) => {
                                const a = props.filterValues?.planeModel;
                                if (!a?.some((ed) => ed == item?.planeModel)) {
                                  const data = { ...props.filterValues };
                                  data.planeModel.push(item?.planeModel);
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.planeModel && data.planeModel?.length > 0
                                      ? data.planeModel.filter((it) => it != item?.planeModel)
                                      : [];
                                  data.planeModel = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item?.planeModel ? item?.planeModel : "[None Specified]"} (
                              {item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ) : (
                          <div class="form-check d-flex align-items-center">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id={`${item?.planeModel}NA`}
                              checked={props.filterValues?.planeModel?.some((ed) => ed == "NA")}
                            />
                            <label
                              class="form-check-label"
                              for={`${item?.planeModel}NA`}
                              onClick={(e) => {
                                const a = props.filterValues?.planeModel;
                                if (!a?.some((ed) => ed == "NA")) {
                                  const data = { ...props.filterValues };
                                  data.planeModel.push("NA");
                                  props.setFilterValues(data);
                                } else {
                                  const data = { ...props.filterValues };
                                  const a =
                                    data.planeModel && data.planeModel?.length > 0
                                      ? data.planeModel.filter((it) => it != "NA")
                                      : [];
                                  data.planeModel = a;
                                  props.setFilterValues(data);
                                }
                              }}
                            >
                              {item?.planeModel ? item?.planeModel : "[None Specified]"} (
                              {item?.count ? item?.count : 0})
                            </label>
                          </div>
                        ),
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fcc-footer d-flex align-items-center">
            <a
              href="javascript:void(0)"
              class="btn btn-black-text"
              data-bs-dismiss="modal"
              onClick={() => props.onHide()}
            >
              Cancel
            </a>
            <a href="javascript:void(0)" class="btn btn-default" onClick={() => props.onHide()}>
              Apply
            </a>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MobileFilter;
